export var LineChartTypes;

(function (LineChartTypes) {
  LineChartTypes["TREND"] = "trend";
  LineChartTypes["PERIOD"] = "period";
})(LineChartTypes || (LineChartTypes = {}));